import { Form } from '@anytag/shared-atoms';
import { ResetPasswordFormSchema } from './schema';
import { Template } from './Template';
import { ResetPasswordFormProps, ResetPasswordFormValues } from './types';

export const ResetPasswordForm = ({
  onSubmit,
  defaultValues = { password: '', passwordConfirm: '' }
}: ResetPasswordFormProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    defaultValues={defaultValues}
    zodSchema={ResetPasswordFormSchema}
    className="mx-auto w-107 rounded-none"
  >
    <Template />
  </Form.Provider>
);

export { type ResetPasswordFormValues };
